import { AxiosResponse } from "axios";
import ApiResponse from "../Models/ApiResponse";
import api from "../Interceptors/Interceptor";

export interface ISystemBackendVersion {
    projectName: string;
    projectBuildVersion: string;
    projectBuildTimestamp: string;
}
export interface ISystemFrontendVersion {
    projectName: string;
    projectBuildVersion: string;
    projectBuildTimestamp: string;
}

export class SystemService {

    public async available(): Promise<AxiosResponse<ApiResponse<any>>> {
        let response = await api.get(`v1/system/available`);
        return response;
    }

    public async retrieveFrontendVersion(): Promise<ISystemFrontendVersion> {
        return Promise.resolve({
            projectName: __APP_NAME__,
            projectBuildVersion: __APP_VERSION__,
            projectBuildTimestamp: __BUILD_TIME__
        });
    }

    public async retrieveBackendVersion(): Promise<AxiosResponse<ApiResponse<ISystemBackendVersion>>> {
        let response = await api.get(`v1/system/version`);
        return response;
    }
}
